import store from '$app/store'

export default {
  install(Vue) {
    Vue.filter('onDateAtTime', function (inDateTime) {
      if (inDateTime.indexOf('T') !== -1 && inDateTime.indexOf('Z') === -1) {
        inDateTime += 'Z';
      }

      const dateTime = new Date(inDateTime);
      const dateString = dateTime.toLocaleDateString();
      const timeString = dateTime.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });

      return `${dateString} at ${timeString}`;
    })

    Vue.filter('formattedDate', function (inDateTime) {
      if (!inDateTime) {
        return '';
      }

      return new Date(inDateTime).toLocaleDateString();
    })

    Vue.filter('formattedGender', function (gender) {
      return !gender ? 'Unknown' : { M: 'Male', F: 'Female' }[gender] || gender;
    })

    Vue.filter('countyNameFromId', function (countyId) {
      if (countyId) {
        const county = store.state.counties.find(c => c.countyId === countyId);
        if (county && county.countyName) {
          return county.countyName;
        }
      }
    })

    Vue.filter('shortCoalitionName', function (coalitionName) {
      if (coalitionName) {
        return coalitionName.replace(/ \(.*\)/gi, '');
      }
    })
  }
}
